import { RecentNetworkAnnouncementsProps } from './RecentNetworkAnnouncementsTypes';
import { classnames } from 'tailwindcss-classnames';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import Container from 'components/helpers/Container';
import { useSession } from 'next-auth/react';
import { isAnonymousUser } from 'lib/auth/client-utils';
import Anonymous from './Anonymous';
import Authenticated from './Authenticated';
import { useEffect, useState } from 'react';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import fnNoOp from 'lib/util/no-op';

const RecentNetworkAnnouncements = ({
  fields,
  ...props
}: RecentNetworkAnnouncementsProps): React.JSX.Element => {
  const { data: session } = useSession();
  const isExperienceEditor = useExperienceEditor();

  const [isAnon, setIsAnon] = useState<boolean>(true);
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return fnNoOp;
    }
    // Current session is considered anonymous if user is in experience editor or anon
    setIsAnon(isExperienceEditor || isAnonymousUser(session?.authz_site as string[]));
    // Set a timeout to give the session a little bit of time to initialize
    const timeoutId = setTimeout(() => setIsMounted(true), 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [session, isExperienceEditor]);
  if (!fields) {
    return <></>;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container
      size="standard"
      dataComponent="authorable/news-and-events/recentnewtorkannouncements"
    >
      <div className={classnames('latest-news')}>
        <div>
          <Heading {...headingProps} />
        </div>
        <div className={classnames({ hidden: !isMounted })}>
          {isAnon ? (
            <Anonymous fields={fields} {...props} />
          ) : (
            <Authenticated fields={fields} session={session} {...props} />
          )}
        </div>
      </div>
    </Container>
  );
};

export default RecentNetworkAnnouncements;
